<template>
    <div>
        <div class="d-inline-block" style="min-width: 32px;">{{ row.user_count }}</div>
        <a :href="row.usersIndexUrl" v-if="canViewUserIndex" class="btn btn-primary btn-sm">
            <i class="fas fa-filter"></i>
        </a>
    </div>
</template>

<script>
  export default {
    props: [
      'row',
    ],

    computed: {
      /**
       * @returns {boolean}
       */
      canViewUserIndex() {
        return this.row.canViewUserIndex;
      },
    },
  }
</script>
